export default "__VITE_ASSET__CLnBIca0__"